import React from 'react'
import { withParsedContext } from '../../withJSSContext'
import { RelatedAuctions } from '@christies/react/components/Magazine'
import { RenderFields } from '../../utils'
import { track, TrackingEvents } from '@christies/react/utils'
import { useRelatedSalesData } from './useRelatedSalesData'
import type { Props } from './types'

const MagazinesRelatedSalesModule: React.FC<Props> = ({ parsedFields, t, parsedSitecoreContext }) => {
  const handleTrack = (_e: React.MouseEvent, index: number): void => {
    track({
      event: TrackingEvents.INTERACTION,
      data: {
        interaction: {
          type: `auction:${index + 1}`,
          location: t('feature-discovery-magazines-relatedauctions-analytics-location', {
            defaultValue: 'stories:related auctions',
          }),
          destination: 'auction',
        },
      },
    })
  }

  const storyAPIEndpoint = parsedSitecoreContext['Discovery.Feature.Magazines.StoriesByIdApiDefinition']
  const auctionsAPIEndpoint = parsedFields?.auctions_endpoint
  const exhibitionsAPIEndpoint = parsedFields?.events_endpoint

  const auctionUrlFormat = parsedFields?.auction_url_format
  const exhibitionUrlFormat = parsedFields?.event_url_format
  const { data, status } = useRelatedSalesData(
    {
      storyAPIEndpoint,
      auctionsAPIEndpoint,
      exhibitionsAPIEndpoint,
      auctionUrlFormat,
      exhibitionUrlFormat,
    },
    import('./mock')
  )

  const relatedAuctionsProps = {
    t: {
      title: parsedFields?.Heading,
    },
    auctions: data || [],
    onClick: handleTrack,
    componentStatus: status,
  }

  return (
    <RenderFields parsedFields={parsedFields}>
      <RelatedAuctions {...relatedAuctionsProps} />
    </RenderFields>
  )
}

export default withParsedContext(MagazinesRelatedSalesModule as React.FC)
